import React from "react";
import { inr } from "@/lib/api";

const fmtDay = (d) => d ? `${d.slice(8, 10)}/${d.slice(5, 7)}` : "—";

const Level = ({ label, value, ltp, sub, color, testid }) => {
  const dist = value && ltp ? Math.round(((ltp - value) / value) * 10000) / 100 : null;
  return (
    <div className="border border-slate-200 px-3 py-2 min-w-[150px]" data-testid={testid}>
      <div className="flex items-center gap-1.5 text-[10px] font-mono font-bold tracking-widest" style={{ color }}>
        <span className="h-0.5 w-4 inline-block" style={{ background: color }} />{label}
      </div>
      <div className="font-mono text-lg text-slate-900" data-testid={`${testid}-value`}>{value ? `₹${inr(value)}` : "—"}</div>
      <div className="text-[10px] font-mono text-slate-500">
        {sub}{dist != null && <span className={dist >= 0 ? "text-emerald-600" : "text-rose-600"}> · price {dist >= 0 ? "+" : ""}{dist}% {dist >= 0 ? "above" : "below"}</span>}
      </div>
    </div>
  );
};

export const TfrLevels = ({ lv, ltp }) => {
  if (!lv) return null;
  return (
    <div className="flex flex-wrap items-stretch gap-2 mb-4" data-testid="tfr-levels">
      {!lv.for_date ? <p className="text-xs font-mono text-slate-500" data-testid="tfr-levels-empty">TFR D / TFR W levels not built yet for this stock</p> : <>
        <Level label="TFR D" value={lv.d} ltp={ltp} color="#FF6D00" sub={`from ${fmtDay(lv.d_day)} session`} testid="tfr-level-d" />
        <Level label="TFR W" value={lv.w} ltp={ltp} color="#FF4081" sub={`from week ${lv.w_week?.[1] ?? "—"}`} testid="tfr-level-w" />
        {lv.adr_hi && <Level label="RANGE MATRIX HIGH / LOW" value={lv.adr_hi} ltp={ltp} color="#38bdf8" sub={`low ₹${inr(lv.adr_lo)}`} testid="tfr-level-adr" />}
        <p className="self-end text-[10px] font-mono text-slate-500 max-w-[220px]">TFR Core from 1-min bars · 24 / 48 rows — same as the TFR INSTITUTIONAL SENSE script · levels for {fmtDay(lv.for_date)}</p>
      </>}
    </div>
  );
};
